module.exports = __webpack_public_path__ + "static/media/appstore_color.1dbf6dae.svg";